"use strict";
var $ = require("../internals/export");
var flattenIntoArray = require("../internals/flatten-into-array");
var aCallable = require("../internals/a-callable");
var toObject = require("../internals/to-object");
var lengthOfArrayLike = require("../internals/length-of-array-like");
var arraySpeciesCreate = require("../internals/array-species-create");
$({ target: "Array", proto: true }, {
  flatMap: function flatMap(callbackfn) {
    var O = toObject(this);
    var sourceLen = lengthOfArrayLike(O);
    var A;
    aCallable(callbackfn);
    A = arraySpeciesCreate(O, 0);
    A.length = flattenIntoArray(A, O, O, sourceLen, 0, 1, callbackfn, arguments.length > 1 ? arguments[1] : void 0);
    return A;
  }
});
